
import { IPCLogsList } from '../../Pages';
/* 🧩 COMPONENTS */
import { Button, Breadcrumb } from "../../Components";

import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from 'framer-motion';
import { useSearchParams } from 'react-router-dom';
/* 🎨 STYLES */
import { Container, ContainerButtons } from "./styles";

const validCruds = [ 'IPClogs' ];

function LogsCruds() {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();

    const crudParam = searchParams.get('crud');
    const currentList = crudParam && validCruds.includes(crudParam) ? crudParam : 'IPClogs';

    const handleChange = (value) => {
        setSearchParams({ crud: value });
    };

    const navigationFlow =  [
        { text: 'administrative', page: '/adm/logs' },
        { text: 'logs', page: '/adm/logs' },
        { text: 'ipclogs', page: '/adm/IPClogs' }
    ]
    return (
        <Container>
            <Breadcrumb flow={navigationFlow}/>

            <ContainerButtons>
                <Button
                    id="ipclogs-list-btn"
                    type='button'
                    text={t("ipclogs.page-title")}
                    color={currentList === 'IPClogs'? 'greenSelected': 'green'}
                    onClick={() => handleChange('IPClogs')}
                />
            </ContainerButtons>

            <AnimatePresence mode="wait">
                <motion.div
                    key={currentList}
                    initial={{ opacity: 0, x: 40 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -40 }}
                    transition={{ duration: 0.3 }}
                >
                    {currentList === 'IPClogs' && <IPCLogsList />}
                </motion.div>
            </AnimatePresence>
        </Container>
    );
}

export default LogsCruds;